import { Component, Input } from '@angular/core';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../services/common.service';


@Component({
  selector: 'calsoft-bannertextwithimage2',
  imports: [CustomFlexLayoutModule, EditorTextComponent],
  templateUrl: './bannertextwithimage2.component.html',
  styleUrl: './bannertextwithimage2.component.scss'
})
export class Bannertextwithimage2Component {


  @Input() item: any;
  @Input() img: any;
  @Input() data: any;
  @Input() categoryId6: any;

  @Input() navigation: any;
  @Input() catId: any;

  @Input() navigatedUrl: any;

  public serverPath = environment.commonImageApi + '/home/';

  public serverPath1 = environment.commonImageApi + '/commonSlider/';

  constructor(private commonService: CommonService,) { }

  goToCategories(id: any) {
    if (id > 0) {
      this.commonService.goToCategory(1, parseInt(id));
    }
    else {
      this.commonService.goToLink(id);

    }
  }


  link(url: any) {
    console.log('Navigating to:', url);
    this.commonService.goToLink(url)
  }

  //     goToLink(url: string) {
  //   window.open(url, '_blank'); // or use router.navigate if internal
  // }

  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }


  isWhiteBackground(color: string): boolean {
    if (!color) return false;

    const normalized = color.trim().toLowerCase();

    return (
      normalized === 'white' ||
      normalized === '#fff' ||
      normalized === '#ffffff' ||
      normalized === 'rgb(255,255,255)'
    );

  }

}
